import { BasicCloudinaryAsset } from '../../../../utils/getCloudinaryItem/getCloudinaryItem';
type ScrollingImage = {
  image: BasicCloudinaryAsset;
  alt: string;
  style: {
    animationDelay: number;
    mobileAnimationDelay: number;
    animationDuration: number;
    zIndex: number;
    top: number;
  };
};
type BusinessLineData = {
  images: ScrollingImage[];
};
export const businessLineData: BusinessLineData = {
  images: [{
    alt: 'Model wearing Stitch Fix women’s clothes including a beige jacket, red and white striped top, and cuffed jeans shorts.',
    image: {
      path: 'v1780007815/creative/onboarding/PMM-N25-SITE-Onboarding%20LOB%20Image%20Refresh-1214589751937270/onboarding-1.png',
      height: 1200,
      width: 800
    },
    style: {
      animationDelay: -86,
      mobileAnimationDelay: -56,
      animationDuration: 102,
      zIndex: 2,
      top: 103
    }
  }, {
    alt: 'Model wearing Stitch Fix men’s clothes including a cream crochet short-sleeved shirt, white tank top, and light khaki pants.',
    image: {
      path: 'v1780007815/creative/onboarding/PMM-N25-SITE-Onboarding%20LOB%20Image%20Refresh-1214589751937270/onboarding-2.png',
      height: 1200,
      width: 800
    },
    style: {
      // using a negative delay value suggests that animation has been playing for that amount of time;
      // that way, images will automatically show up in the viewport on page load
      animationDelay: -78,
      mobileAnimationDelay: -47,
      animationDuration: 105,
      zIndex: 3,
      top: 4
    }
  }, {
    alt: 'Two kids wearing Stitch Fix clothes including a tie-dye graphic tee, blue and beige striped shirt, light khaki shorts, denim shorts, and sneakers.',
    image: {
      path: 'v1780007815/creative/onboarding/PMM-N25-SITE-Onboarding%20LOB%20Image%20Refresh-1214589751937270/onboarding-3.png',
      height: 1200,
      width: 800
    },
    style: {
      animationDelay: -67,
      mobileAnimationDelay: -34,
      animationDuration: 108,
      zIndex: 1,
      top: 83
    }
  }, {
    alt: 'Model wearing Stitch Fix women’s clothes including a printed white maxi dress, cream open-knit sweater, black sandals, and carrying a woven bag.',
    image: {
      path: 'v1780007815/creative/onboarding/PMM-N25-SITE-Onboarding%20LOB%20Image%20Refresh-1214589751937270/onboarding-4.png',
      height: 1200,
      width: 800
    },
    style: {
      animationDelay: -51,
      mobileAnimationDelay: -19,
      animationDuration: 105,
      zIndex: 3,
      top: 0
    }
  }, {
    alt: 'Model wearing Stitch Fix women’s clothes including a pink sleeveless top and matching pink shorts, with a woven bag over one shoulder.',
    image: {
      path: 'v1780007814/creative/onboarding/PMM-N25-SITE-Onboarding%20LOB%20Image%20Refresh-1214589751937270/onboarding-5.png',
      height: 1200,
      width: 800
    },
    style: {
      animationDelay: -42,
      mobileAnimationDelay: -9,
      animationDuration: 110,
      zIndex: 5,
      top: 111
    }
  }, {
    alt: 'Model wearing Stitch Fix men’s clothes including a tan jacket, sage green T-shirt, light blue jeans, and a white baseball cap.',
    image: {
      path: 'v1780007815/creative/onboarding/PMM-N25-SITE-Onboarding%20LOB%20Image%20Refresh-1214589751937270/onboarding-6.png',
      height: 1200,
      width: 800
    },
    style: {
      animationDelay: -28,
      mobileAnimationDelay: 4,
      animationDuration: 108,
      zIndex: 4,
      top: 22
    }
  }, {
    alt: 'Model wearing Stitch Fix kids’ clothes including a pink cardigan, light blue jeans, and pink shoes.',
    image: {
      path: 'v1780007815/creative/onboarding/PMM-N25-SITE-Onboarding%20LOB%20Image%20Refresh-1214589751937270/onboarding-7.png',
      height: 1200,
      width: 800
    },
    style: {
      animationDelay: -16,
      mobileAnimationDelay: 14,
      animationDuration: 110,
      zIndex: 6,
      top: 98
    }
  }, {
    alt: 'Model wearing Stitch Fix men’s clothes including a light gray blazer, dark T-shirt, white pants, and dark brown loafers.',
    image: {
      path: 'v1780007816/creative/onboarding/PMM-N25-SITE-Onboarding%20LOB%20Image%20Refresh-1214589751937270/onboarding-8.png',
      height: 1200,
      width: 800
    },
    style: {
      animationDelay: -1,
      mobileAnimationDelay: 28,
      animationDuration: 108,
      zIndex: 4,
      top: 20
    }
  }]
};